import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currentText", "isSaving"];
import debounce from 'transmute/debounce';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import SavableFormLabel from './SavableFormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const onTextChange = debounce(500, (value, callback) => callback(value));
function NotesTextArea(_ref) {
  let {
      currentText = '',
      isSaving = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    currentText,
    isSaving
  }, rest);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "notes-text-area-label",
      isSaving: props.isSaving,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.notes.label"
      })
    }), /*#__PURE__*/_jsx(TextArea, {
      "data-test-id": "notes-text-area-text-area",
      defaultValue: props.currentText,
      placeholder: I18n.text('app.escalations.fields.notes.placeholder'),
      rows: 4,
      onChange: ({
        target: {
          value
        }
      }) => onTextChange(value, props.onTextChange)
    })]
  });
}
NotesTextArea.propTypes = {
  currentText: PropTypes.string,
  isSaving: PropTypes.bool,
  onTextChange: PropTypes.func.isRequired
};
export default NotesTextArea;